module.exports = __webpack_public_path__ + "build/img/YM.bbb07544.png";